/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
    Modal,
    ModalTitle,
    Label,
    Button,
    TitleSection,
    ContentSection,
    FooterSection,
    Row,
    Column,
    StepController,
    Step,
    tryLogin,
} from "trux"
import { PhoneForm } from "./PhoneForm"
import "./WelcomeToTeam.css"

export const WelcomeToTeam = (props) => {
    const dispatch = useDispatch()

    const [step, setStep] = useState("loading")

    const [open, setOpen] = useState(true)
    const team = useSelector((state) => state.team.value)
    const user = useSelector((state) => state.user.value)
    const [tryingLogin, setTryingLogin] = useState(!!user)

    let teamId = props.match.params.team_name
    let teamName = "..."
    if (team && team.title) {
        teamName = team.title
    }

    const onClose = () => {
        setOpen(false)
        setTimeout(() => {
            props.history.replace(
                props.location.pathname.replace(/\/welcome.*?$/gi, "")
            )
        }, 600)
    }

    useEffect(() => {
        if (!tryingLogin) {
            setTryingLogin(true)
            setTimeout(() => {
                tryLogin(props.location.pathname, (user, error) => {
                    console.log("callback", user, error)
                    if (error) {
                        setStep("login-error")
                    } else {
                        setStep("add-emails")
                        dispatch({
                            type: "COMMON_RESET",
                        })
                    }
                })
            }, 2000)
        }
    }, [teamName, team, user, dispatch, props.location.pathname, tryingLogin])

    return (
        <Modal
            trkContext="Welcome to the team"
            className="WelcomeToTeam"
            open={open}
            onShadeClick={onClose}
        >
            <StepController step={step}>
                <Step name="loading">
                    <TitleSection onCloseClick={onClose}>
                        <ModalTitle content="Welcome" />
                    </TitleSection>
                    <ContentSection>
                        <Column center span="12">
                            <Label
                                center
                                type={Label.Type.Body}
                                bold
                                content="Loading team, just a second ..."
                                marginBottom="5"
                                marginTop="5"
                            />
                        </Column>
                    </ContentSection>
                </Step>
                <Step name="login-error">
                    <TitleSection onCloseClick={onClose}>
                        <ModalTitle content="Welcome" />
                    </TitleSection>
                    <ContentSection>
                        <Column center span="12">
                            <Label
                                center
                                type={Label.Type.Heading4}
                                content="This welcome link has expired."
                                marginBottom="8"
                            />
                            <Button
                                type={Label.Type.Heading5}
                                span="12"
                                content="Try signing in"
                                href={`/#/${teamId}/session/login`}
                                trkAction="Try Signing In Pressed"
                            />
                        </Column>
                    </ContentSection>
                </Step>
                <Step name="add-emails">
                    <TitleSection onShadeClick={onClose}>
                        <ModalTitle content="Welcome" onCloseClick={onClose} />
                    </TitleSection>
                    <PhoneForm teamName={teamName} onDone={onClose} />
                </Step>
            </StepController>
        </Modal>
    )
}
